<template>
  <div>
    <b-row>
      <b-col>
        <filtered-table :settings="tableSettings">
        </filtered-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Constants from '../Common/Constants.js'

export default {
  name: "StationSubscriptionList",
  mixins: [
  ],
  props: [
      'stationId'
  ],
  data() {
    let base = this;
    return {
      tableSettings: {
        query: 'subscriptions',
        columns: [
          {
            key: 'id',
            name: 'ID',
            alwaysLoad: true,
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'applicationUser.email',
            name: 'Email Address',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'trigger',
            name: 'Trigger',
            visible: true,
            filter: 'select',
            selectOptions: Constants.triggers
          },
        ],
        getDefaultFilter: () => {
          return 'Station.Id = \"' + this.stationId + '\"';
        },
        rowClicked: function (item, context) {
          context.$router.push('/subscription/' + item.id + '?returnPage=station')
        }
      }
    }
  },
  methods: {
  },
  mounted () {
  }
};
</script>